<template>
  <b-container>
    <b-form-group label="Nome" label-for="input-form-name">
      <b-form-input
        id="input-form-name"
        type="text"
        v-model="model.name"
        required
        placeholder="Insira o nome para o script"
      ></b-form-input>
    </b-form-group>
    <b-form-group label="Descrição" label-for="input-form-description">
      <b-form-input
        id="input-form-name"
        type="text"
        v-model="model.description"
        required
        placeholder="Insira a descrição para o script"
      ></b-form-input>
    </b-form-group>
    <b-row>
      <b-col cols="3">
        <b-form-group
          label="Tipo do script"
          label-for="input-form-profile-fill"
        >
          <single-select
            id="input-form-profile-fill"
            :value.sync="model.scriptType"
            :value-property="'value'"
            label="text"
            :options="scriptType"
          />
        </b-form-group>
      </b-col>
      <b-col cols="3">
        <b-form-group label="Id da empresa" label-for="input-form-profile-fill">
          <b-form-input
            id="input-form-name"
            type="number"
            v-model="model.companyId"
            required
            placeholder="Insira id da empresa para o script"
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>

    <predefined-script-variable-crud
      :variables.sync="model.variables"
      :companyOptions="companyOptions"
      
    ></predefined-script-variable-crud>

    <custom-codemirror
      class="mt-4"
      :model.sync="model.script"
      :readonly="true"
    ></custom-codemirror>

    <!-- {{ model }} -->
  </b-container>
</template>
<script>
export default {
  name: "PredefinedScriptCrud",
  props: {
    model: Object,
  },
  components: {
    SingleSelect: () => import("@/components_rms/base/SingleSelect.vue"),
    CustomCodemirror: () =>
      import("@/components_rms/checklist/form/CustomCodemirror.vue"),
    PredefinedScriptVariableCrud: () =>
      import("./PredefinedScriptVariableCrud.vue"),
  },
  created() {
    this.loadCompanyOptions();
  },
  data() {
    return {
      companyOptions: [],
      scriptType: [
        { value: 0, text: "Calculado" },
        { value: 1, text: "Validação" },
        { value: 2, text: "Processamento" },
        { value: 3, text: "Pós processamento" },
        { value: 4, text: "Validação de pendência" },
      ],
    };
  },
  methods: {
    loadCompanyOptions() {
      this.$apiChecklist
        .get("/systemFieldType/getCompanyTypes/")
        .then((response) => {
          this.companyOptions = response.data;
        });
    },
  },
};
</script>